// Group G4b's own words: the overlays (#60 Dialog and its presets, #61 SlideOver), the candidate hero (#47), Home's
// widget registry (#65), the filter bar (#75) and the selection bar (row 111). Each quotes the line of his glossary or
// of the vendored design-system excerpts it is taken from; labels.test.mjs proves every quote, text and status.
// Words the shared module already carries (G §17 verbs, profile statuses, Candidate ID) are imported from there.

import { defineLabels } from "../labels";

const PRESETS = "presets (Schedule · Reschedule · Cancel · Decline this interview · Release packets · Merge · Recover · Designate · Link to requisition · Add candidate · Request hold / cancellation / reopen · Record decline · Revise own score · Override)";
const QE15_DECLINE = "*Decline this interview* · *Keep this interview* · *VP+ rule applied*";
const QE15_PROFILE = "*Edit profile* · *Link to requisition* · *Reuse an existing profile* · *Review parsed values*";
const SLIDE = "*Panel change* · the scheduling request · the single-candidate decision";
const HERO = "name · *Candidate ID* · *Active / Archived / Merged* · *Internal / External* · *Talent community*";
const WIDGETS = "*Own open reqs* · *Assigned interviewer work elsewhere* · *Assigned reqs/interviews/packets/scorecards/debriefs* · scope words";
const FILTERS = "§7.2 filter names · *Saved views* · *Group by* · *Sort* · *Export* · *Drill-down*";
const FILTER_ROW = "one wrapping row: search `inp` · date `select` with presets";
const SELBAR = "F one tab stop in · D *Submit* until one selected";
const REASONS = "*Reason* · *Rationale* · *Reporting category* · *Final notes* · *Decline reason* · *Withdrawal reason*";

/** #60 Dialog presets: the titles DS #60 lists, in its order (his verbs and nouns; Q-E15 lines are pending). */
export const DIALOG_LABELS = /* @__PURE__ */ defineLabels({
  schedule: { text: "Schedule" },
  reschedule: { text: "Reschedule" },
  cancel: { text: "Cancel" },
  declineThisInterview: { text: "Decline this interview" },
  keepThisInterview: { text: "Keep this interview" },
  releasePackets: { text: "Release packets" },
  merge: { text: "Merge" },
  recover: { text: "Recover" },
  designate: { text: "Designate" },
  linkToRequisition: { text: "Link to requisition" },
  editProfile: { text: "Edit profile" },
  addCandidate: { text: "Add candidate" },
  requestHoldCancellationReopen: { text: "Request hold / cancellation / reopen" },
  recordDecline: { text: "Record decline" },
  reviseOwnScore: { text: "Revise own score" },
  override: { text: "Override" },
});

/** #60 Dialog / #61 SlideOver: the close button's own name, asked (Q-3) so a Cancel dialog never names three controls
 * Cancel. DS #60's line is the sense: the close, beside Escape, that ends the dialog without its action. */
export const OVERLAY_LABELS = /* @__PURE__ */ defineLabels({
  close: { text: "Close" },
});

/** #61 SlideOver: the slide-over's title word, and the reason field the gallery's bodies carry (DS #77). */
export const SLIDE_LABELS = /* @__PURE__ */ defineLabels({
  panelChange: { text: "Panel change" },
  reason: { text: "Reason" },
  declineReason: { text: "Decline reason" },
});

/** The rule sentences the overlays' blocked and refused states carry in the gallery (his, verbatim). */
export const OVERLAY_RULES = /* @__PURE__ */ defineLabels({
  cannotScheduleBeforeStep9: { text: "Cannot schedule before Step 9 advancement." 

},
  cannotScheduleIfDeclined: { text: "Cannot schedule if required panel assignment is declined or coverage invalid." 


},
  validateCoverage: { text: "Validate coverage before finalization." },
  offerDeclineReasonRequired: { text: "Offer decline reason required." },
});

/** #47 Candidate hero: the profile words DS #47 carries beyond the shared statuses. */
export const HERO_LABELS = /* @__PURE__ */ defineLabels({
  internal: { text: "Internal" },
  external: { text: "External" },
  talentCommunity: { text: "Talent community" },
});

/** #65 Widgets: Home's section and scope words (DS #65). */
export const WIDGET_LABELS = /* @__PURE__ */ defineLabels({
  ownOpenReqs: { text: "Own open reqs" },
  assignedInterviewerWorkElsewhere: { text: "Assigned interviewer work elsewhere" },
});

/** #75 FilterBar: the control names DS #75 gives, and the empty form's chip. */
export const FILTERBAR_LABELS = /* @__PURE__ */ defineLabels({
  search: { text: "Search" },
  date: { text: "date" },
  savedViews: { text: "Saved views" },
  groupBy: { text: "Group by" },
  sort: { text: "Sort" },
  all: { text: "All" },
});

/** row 111 SelectionBar: its name and the blocked Submit's reason (the DS row's own line; flagged for Q-E15). */
export const SELBAR_LABELS = /* @__PURE__ */ defineLabels({
  candidateSlateSubmission: { text: "Candidate slate submission" },
  submitUntilOneSelected: { text: "Submit until one selected" },
});
